require("./style.css");
import React from "react";
import AcquireWebComponent from "../../framework/MaterialUI";

class SideBar extends AcquireWebComponent {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      mainFlexStyle,
      clientId,
      reportType = "consumer",
      pageUrl,
    } = this.props;
    return (
      <div
        id="left-nav"
        style={{ flex: mainFlexStyle ? mainFlexStyle : "0 0 280px" }}
      >
        <div className="light-grey-border">
          <div
            onClick={() => {
              this.props.history.push(
                "/insights/" +
                  reportType +
                  "?cid=" +
                  clientId +
                  "&nav=overview",
              );
            }}
            style={{ height: "58px", padding: "15px 20px 15px 35px" }}
            className={
              this.props.type === "overview"
                ? "side-bar-item-active"
                : "side-bar-item"
            }
          >
            Overview
          </div>
          {reportType === "consumer" ? (
            [
              <div
                key="3"
                onClick={() => {
                  this.props.history.push(
                    "/insights/consumer?cid=" + clientId + "&nav=device",
                  );
                }}
                style={{ height: "58px", padding: "15px 20px 15px 35px" }}
                className={
                  this.props.type === "device"
                    ? "side-bar-item-active"
                    : "side-bar-item"
                }
              >
                Devices
              </div>,
            ]
          ) : (
            <div
              key="3"
              onClick={() => {
                this.props.history.push(
                  "/insights/business?cid=" + clientId + "&nav=fir",
                );
              }}
              style={{ height: "58px", padding: "15px 20px 15px 35px" }}
              className={
                this.props.type === "fir"
                  ? "side-bar-item-active"
                  : "side-bar-item"
              }
            >
              Business Firmographic
            </div>
          )}
          <div
            onClick={() => {
              this.props.history.push(
                "/insights/" + reportType + "?cid=" + clientId + "&nav=pop",
              );
            }}
            style={{ height: "58px", padding: "15px 20px 15px 35px" }}
            className={
              this.props.type === "pop"
                ? "distribution-type-active"
                : "distribution-type"
            }
          >
            Most Popular Pages
          </div>
        </div>
      </div>
    );
  }
}

export default SideBar;



// WEBPACK FOOTER //
// ./src/components/Insights/website/SideBar.jsx